export const zIndexes = {
  default: 0,
  dropdown: 1,
  modalOverlay: 2,
  modal: 3,
};
